import React from "react";
import {Button, Drawer, Form, Input, InputNumber, Modal, Select, Spin, Table} from "antd";
import {BusinessCategory} from "./BusinessCategory";
import {GeneratorGet, GeneratorList, GeneratorPost} from "../models/generator";
import {EditGeneratorData} from "../pages/tracks/data_management/generator_data/popups/EditGeneratorData"
import {pagination} from "../controller/Utils";
import {ChooseBillToDrawer} from "../pages/tracks/quotes/popups/ChooseBillToDrawer";
import {IndustryTypeFilter} from "./IndustryType";

const FormItem = Form.Item;
const {TextArea} = Input;
const Search = Input.Search;

class GeneratorFilterForm extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    selectedGenerator: {},
    fetching: false,
    generatorListVisible: false,
    confirmLoading: false,
    loading: false,
    search: '',
    pagination: pagination,
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    const requestData = {
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.field}`,
      search: this.state.search,
      ...filters,
    };
    GeneratorList(requestData)
      .then(body => {
        const data = body.data.results;
        this.setState({data, fetching: false, loading: false});
      });
  };

  showDrawer = (row_id) => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchGenerator = (value = '') => {
    this.setState({ loading: true, fetching: true, search: value});
    const requestData = { 'search': value };
    GeneratorList(requestData)
      .then(body => {
        const data = body.data.results;
        const pagination = { ...this.state.pagination };
        pagination.total = body.data.count;
        this.setState({ data, fetching: false, loading: false, pagination});
      });
  };

  showGeneratorList = () => {
    this.setState({ generatorListVisible: true })
  };

  hideGeneratorList = () => {
    this.setState({confirmLoading: false, data: [], generatorListVisible: false});
  };
  handleDrawerSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        GeneratorPost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: `${response.company_name} ${response.account_number}` },
              selectedGenerator: response
            });
            this.props.onChange(response.id);
          });
      }
    });
  };
  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
    this.props.onChange(value.key);
    this.setGeneratorToSelectedData(value.key)
  };

  setSelectedValue = (value) => {
    this.setState({confirmLoading: true});
    if( value.id !== undefined) {
      if(!this.props.disableBill)
        this.setState({showBillToDrawer: true, generatorID: value.id});
      this.handleChange({key: value.id, label: `${value.company_name} ${value.account_number}`});
    }
    this.hideGeneratorList()
  };
  setGeneratorToSelectedData = (id) => {
    GeneratorGet(id)
      .then(response => {
        this.setState({selectedGenerator: response.data})
      })
  };

  onRowUpdateClick = (row_id) => {
    this.setEditGenerator(true);
    this.setState({row_id})
  };

  setBillToDrawer = (showBillToDrawer) => {
    this.setState({showBillToDrawer})
  };

  onChooseBillToValue = (value) => {
    const generator = this.state.value;
    this.props.onChange(generator.key, value);
  }

  setEditGenerator(modelEditGenerator) {
    const {row_id} = this.state;
    this.setState({modelEditGenerator});
    if (!modelEditGenerator)
      this.setState({row_id: modelEditGenerator});
    if(row_id)
      this.setGeneratorToSelectedData(row_id)
  }

  columns = [{
      title: 'Account Number',
      dataIndex: 'account_number',
      sorter: true
  }, {
      title: 'Company Name',
      dataIndex: 'company_name',
      sorter: true
  }, {
      title: 'Phone',
      dataIndex: 'phone',
  }, {
      title: 'Address',
      dataIndex: 'address',
      render: (address) => <span className="select-data-add">{address}</span>,
  }, {
      title: 'City',
      dataIndex: 'city',
      sorter: true
  }, {
      title: 'Zip Code',
      dataIndex: 'zip_code',
  },
  {
    title: 'Action',
    render: (row) => <div className="select-pop-action">
      <Button loading={this.state.value.key === row.id && this.state.confirmLoading} className="ant-btn ant-btn-primary"
        onClick={() => this.setSelectedValue(row)}>
        <i className="fa fa-check"/>
      </Button>
      <Button onClick={() => this.onRowUpdateClick(row.id)} className="ant-btn ant-btn-primary edit-gen"><i className="fa fa-pencil"/></Button>
    </div>
  }];

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }
  render() {
    const {fetching, data, value, fields, generatorListVisible, loading, pagination, selectedGenerator} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <div>
          <div className="pos-relative">
            <Select labelInValue showSearch value={value} placeholder="Select Generator"
              notFoundContent={fetching ? <Spin size="small" /> : null} filterOption={false}
              style={{ width: "100%" }}>
            </Select>
            <Button className="import-btn-pop select-gen-input" htmlType='button' type="primary" onClick={this.showGeneratorList}>
            </Button>
               <Button className="plus-btn-pop" htmlType='button' type="primary" onClick={this.showDrawer}>
                <i className="fa fa-plus" />
              </Button>
          </div>
            {selectedGenerator.id && <div className="col-12 generator-data">
              <p className="selected-name-g">{selectedGenerator.company_name} <a onClick={() => this.onRowUpdateClick(selectedGenerator.id)} className="edit-gen-btn"><i className="fa fa-pencil"> </i> </a></p>
                <p>ID: <span>{selectedGenerator.account_number}</span></p>
                <p>Email: <span>{selectedGenerator.email}</span></p>
                <p>Address: <span>{selectedGenerator.address}</span></p>
                <p>City: <span>{selectedGenerator.city}</span></p>
                <p>State: <span>{selectedGenerator.state}</span></p>
                <p>Zip Code: <span>{selectedGenerator.zip_code}</span></p>
                <p>Phone: <span>{selectedGenerator.phone}</span></p>
                <p>Contact: <span>{selectedGenerator.contact}</span></p>
                <p>Notes: <span>{selectedGenerator.notes}</span></p>
                <p>Industry Type: <span>{selectedGenerator.industry_type?selectedGenerator.industry_type.name: '-'}</span></p>
              </div>
            }
          <Drawer title="Add Generator" placement="right" onClose={this.onClose} visible={this.state.visible}
            className="floating-form" destroyOnClose={true}>
            <Form>
              <FormItem label="Email">
                {getFieldDecorator('email')(<Input placeholder="Enter email" />)}
              </FormItem>
              <FormItem label="Company Name">
                {getFieldDecorator('company_name', {
                  rules: [{ required: true, message: 'Please input company name' }],
                })(<div><Input className="uppercase-letter" placeholder="Enter company name" /></div>)}
              </FormItem>
              <FormItem label="Address">
                {getFieldDecorator('address', {
                  rules: [{ required: true, message: 'Please input address' }],
                })(<TextArea placeholder="Enter address" autosize={{ minRows: 2, maxRows: 10 }}/>)}
              </FormItem>
              <FormItem label="City">
                {getFieldDecorator('city', {
                  rules: [{ required: true, message: 'Please input city' }],
                })(<Input placeholder="Enter city" />)}
              </FormItem>
              <FormItem label="State">
                {getFieldDecorator('state', {
                  rules: [{ required: true, message: 'Please input state' }],
                })(<Input placeholder="Enter state" />)}
              </FormItem>
              <FormItem label="Zip Code">
                {getFieldDecorator('zip_code', {
                  rules: [{ required: true, message: 'Please input zip code' }],
                })(<Input placeholder="Enter zip code" />)}
              </FormItem>
              <FormItem label="Phone">
                {getFieldDecorator('phone', {
                  rules: [{ required: true, message: 'Please input phone' }],
                })(<Input placeholder="Enter phone" />)}
              </FormItem>
              <FormItem label="Contact">
                {getFieldDecorator('contact', {
                  rules: [{ required: true, message: 'Please input contact' }],
                })(<Input placeholder="Enter contact" />)}
              </FormItem>
              <FormItem label="Industry Type">
                {getFieldDecorator('industry_type', {
                  rules: [{required: true, message: 'Please select industry type name'}],
                })(<IndustryTypeFilter onRef={ref => (this.industry_type = ref)} {...fields} />)}
              </FormItem>
              <FormItem label="Notes">
                {getFieldDecorator('notes')(<TextArea placeholder="Enter notes" autosize={{ minRows: 4 }} />)}
              </FormItem>
              <Button type="primary" htmlType="button" onClick={this.handleDrawerSubmit}>Add Generator</Button>
            </Form>
          </Drawer>
          <Modal className="gen-list-mdl" destroyOnClose={true} title="Generators List" onCancel={this.hideGeneratorList} visible={generatorListVisible} width='90%'>
            <Search placeholder="Search Here For Generator" className="gen-tbl-search" onSearch={this.fetchGenerator} style={{ width: 500 }} />
            <Table onRow={(row) => { return {  onClick: () => {this.setSelectedValue(row)}};}} className="select-data-tbl" pagination={pagination} onChange={this.handleTableChange} loading={loading} columns={this.columns} dataSource={data} rowKey={row => row.id} />
          </Modal>
          <EditGeneratorData fetch={() => this.fetchGenerator()} row_id={this.state.row_id} visible={this.state.modelEditGenerator} setModelVisible={() => this.setEditGenerator(false)} />
          <ChooseBillToDrawer visible={this.state.showBillToDrawer} onChooseBillTo={(value) => this.onChooseBillToValue(value)} generatorID={this.state.generatorID} setDrawerVisible={() => this.setBillToDrawer(false)} />
          </div>
    );
  }
}

export const GeneratorFilter = Form.create()(GeneratorFilterForm);


// WEBPACK FOOTER //
// ./src/filters/Generator.jsx